var render = function (_h,_vm) {var _c=_vm._c;return _c('h4',{class:['text-center uppercase', _vm.data.class, _vm.data.staticClass]},[_vm._v(" "+_vm._s(_vm.props.heading)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }